import { Card, Stack, Button, Group } from "@mantine/core";
import { AdvancedPaymentInformation } from "common"
import { useCallback } from "react";
import CardInfo from "./CardInfo";
import { format } from "date-fns";
import { it } from "date-fns/locale";

type CurrentPlanProps = {
    plan: AdvancedPaymentInformation,
    loading: { name: string, state: boolean },
    showActiveBtn: boolean,
    ltd?: boolean,
    onCancel: () => void,
    onPause: () => void,
    onActive: () => void
}

const CurrentPlan = (props: CurrentPlanProps) => {
    const getTypeHumanReadable = () => {
        if(props.plan.type === "monthly") return "Mensile";
        if(props.plan.type === "annual")  return "Annuale";
        if(props.plan.type === "ltd_schedinecloud") return "Schedine Cloud";

        return "Prova Gratuita";
    };
    
    const getStatusHumanReadable = () => {
        if(props.plan.status === "canceled") return "Cancellato";
        if(props.plan.status === "expired") return "Scaduto";
        if(props.plan.status === "paused") return "In pausa";

        return "Attivo";
    };

    return(
        <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Stack>
                <CardInfo label="Piano" value={ getTypeHumanReadable() } />
                <CardInfo label="Creato il" value={ format(props.plan.startDate, "dd MMMM yyyy", { locale: it }) } />
                <CardInfo label="Scade il" value={ format(props.plan.endDate, "dd MMMM yyyy", { locale: it }) } />
                <CardInfo label="Status" value={ getStatusHumanReadable() } />

                {
                    (!props.ltd && props.plan.type !== "trial" && props.plan.status !== "canceled")
                    &&
                    <>
                        <Stack hiddenFrom="md">
                            <Button 
                                color="red" 
                                fullWidth 
                                onClick={ props.onCancel } 
                                loading={ props.loading.name === "canceled" && props.loading.state === true }
                                disabled={ props.loading.name !== "canceled" && props.loading.state === true }
                            >
                                Cancella abbonamento
                            </Button>

                            {
                                !props.showActiveBtn 
                                &&
                                <Button 
                                    variant="light" 
                                    fullWidth 
                                    onClick={ props.onPause } 
                                    loading={ props.loading.name === "paused" && props.loading.state === true }
                                    disabled={ props.loading.name !== "paused" && props.loading.state === true }
                                >
                                    Pausa
                                </Button>
                            }

                            {
                                props.showActiveBtn
                                &&
                                <Button
                                    onClick={ props.onActive }
                                    loading={ props.loading.name === "active" && props.loading.state === true }
                                    disabled={ props.loading.name !== "active" && props.loading.state === true }
                                >
                                    Riattiva
                                </Button>
                            }
                        </Stack>

                        <Group visibleFrom="md" justify="flex-end">
                            {
                                !props.showActiveBtn 
                                &&
                                <Button 
                                    variant="light" 
                                    onClick={ props.onPause }
                                    loading={ props.loading.name === "pause" && props.loading.state === true }
                                    disabled={ props.loading.name !== "pause" && props.loading.state === true }
                                >
                                    Pausa
                                </Button>
                            }

                            {
                                props.showActiveBtn
                                &&
                                <Button
                                    onClick={ props.onActive }
                                    loading={ props.loading.name === "active" && props.loading.state === true }
                                    disabled={ props.loading.name !== "active" && props.loading.state === true }
                                >
                                    Riattiva
                                </Button>
                            }

                            <Button 
                                color="red" 
                                onClick={ props.onCancel }
                                loading={ props.loading.name === "canceled" && props.loading.state === true }
                                disabled={ props.loading.name !== "canceled" && props.loading.state === true }
                            >
                                Cancella abbonamento
                            </Button>
                        </Group>
                    </>
                }

                {
                    props.ltd
                    &&
                    <>
                        {
                            !props.showActiveBtn 
                            &&
                            <Button 
                                variant="light" 
                                fullWidth 
                                onClick={ props.onPause } 
                                loading={ props.loading.name === "paused" && props.loading.state === true }
                                disabled={ props.loading.name !== "paused" && props.loading.state === true }
                            >
                                Disattiva
                            </Button>
                        }

                        {
                            props.showActiveBtn
                            &&
                            <Button
                                onClick={ props.onActive }
                                loading={ props.loading.name === "active" && props.loading.state === true }
                                disabled={ props.loading.name !== "active" && props.loading.state === true }
                            >
                                Riattiva
                            </Button>
                        }
                    </>
                }
            </Stack>
        </Card>
    );
};

export default CurrentPlan;